import * as React from 'react';

export interface UserProps {
  area_code?: string;
  account?: string;
  headimgurl?: string;
  nickname?: string;
  org_id?: string;
  role?: string;
  user_id?: string;
  company?: string;
  email?: string;
  email_verify?: boolean;
  state?: string;
}

export interface UserContextProps {
  user: UserProps;
  handleUser: (next: UserProps) => void;
  formatUserInfo: (info: UserProps) => UserProps;
}

export const UserContext = React.createContext<UserContextProps>({
  user: {},
  handleUser: (next: UserProps) => {
    // Do nothing
  },
  formatUserInfo: (info: UserProps) => ({})
});
